// AuthPage.tsx
import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SignInForm from '../../components/auth/formSignin';
import ForgotPasswordForm from '../../components/auth/formForgot';
import OTPForm from '../../components/auth/formOTP';
import { useAuthStore } from '../../stores/auth';

const Auth: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'signin' | 'forgot'>('signin');
    const { setOTP, otp } = useAuthStore();

    // Variants cho underline indicator của tab (hai tab có width bằng nhau)
    const indicatorVariants = {
        signin: { left: 0 },
        forgot: { left: '50%' },
    };

    const handleOTPCancel = useCallback(() => {
        setOTP({
            email: null,
            timeEx: null,
            openForm: false
        });
    }, [setOTP]);

    // Variants cho hiệu ứng form: nếu đang ở tab signin thì slide từ phải sang trái,
    // còn nếu ở tab forgot thì ngược lại.
    const formVariants =
        activeTab === 'signin'
            ? { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, exit: { opacity: 0, x: -50 } }
            : { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, exit: { opacity: 0, x: 50 } };

    return (
        <div className="flex-1 justify-center items-center h-screen flex">
            <div className="max-w-md mx-auto p-4 shadow-md rounded-md overflow-hidden min-w-80 min-h-80">

                {/*  logo and title */}
                <div className="flex flex-col items-center justify-center mb-5">
                    <img src={"https://slack-imgs.com/?c=1&o1=gu&url=https%3A%2F%2Femoji.slack-edge.com%2FT024MFQVDD2%2Flt%2F3100f2ff4b59dceb.png"} alt="logo" className="w-10 h-10 rounded-lg" />
                    <h4 className="text-2xl font-medium text-blue-500">LuxTech</h4>
                </div>

                {/* Nếu chưa submit, hiển thị 2 tab và form tương ứng */}
                <div className="relative mb-4 border border-gray-300 rounded-md">
                    <div className="flex">
                        <button
                            onClick={() => setActiveTab('signin')}
                            className={`flex-1 py-2 text-center border-r border-blue-500 ${activeTab === 'signin' ? 'text-blue-500' : 'text-gray-500'
                                }`}
                        >
                            Đăng nhập
                        </button>
                        <button
                            onClick={() => setActiveTab('forgot')}
                            className={`flex-1 py-2 text-center ${activeTab === 'forgot' ? 'text-blue-500' : 'text-gray-500'
                                }`}
                        >
                            Quên mật khẩu
                        </button>
                    </div>
                    {/* Underline indicator chuyển động dưới tab */}
                    <motion.div
                        className="absolute bottom-0 h-1 bg-blue-500"
                        style={{ width: '50%' }}
                        variants={indicatorVariants}
                        animate={activeTab}
                        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                    />
                </div>

                <AnimatePresence mode="wait" >
                    {activeTab === 'signin' ? (
                        <motion.div
                            key="signin"
                            variants={formVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit"
                            transition={{ duration: 0.3 }}
                            className="w-full h-3/4"
                        >
                            <SignInForm />
                        </motion.div>
                    ) : (
                        <>
                            {
                                !otp?.openForm ?
                                    <motion.div
                                        key="forgot"
                                        variants={formVariants}
                                        initial="initial"
                                        animate="animate"
                                        exit="exit"
                                        transition={{ duration: 0.3 }}
                                        className="w-full h-3/4"
                                    >
                                        <ForgotPasswordForm />
                                    </motion.div>
                                    :
                                    <motion.div
                                        key="otp"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <OTPForm onCancel={handleOTPCancel} />
                                    </motion.div>
                            }
                        </>
                    )}
                </AnimatePresence>
            </div >
        </div >
    );
};

export default Auth;